import { Button, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { DrawerSauces } from "./styled";
import { TableRulesSushiLunch } from "./TableRulesSushiLunch";
import React from "react";
import { RulesSushiLunchForm } from "./form";

export const RulesSushiLunch = () => {
  const [openModalCreateRule, setOpenModalCreateRule] =
    React.useState<boolean>(false);
  return (
    <AdminMenuLayout pageDescription="Reglas de Sushi Lunch" title="Sushi Lunch">
      <div style={{ padding: "24px", background: "#fff", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", overflow: "hidden" }}>
        <div style={{ 
          marginBottom: 24, 
          display: "flex", 
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #f0f0f0",
          paddingBottom: 16
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, margin: 0, color: "#262626" }}>Reglas de Sushi Lunch</h2>
          
          <Space size={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              onClick={() => setOpenModalCreateRule(true)}
              style={{ 
                borderRadius: "30px", 
                fontWeight: 600,
                padding: "0 24px",
                height: 44,
                boxShadow: "0 4px 10px rgba(233, 87, 53, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: 8
              }}
            >
              Agregar una regla
            </Button>
          </Space>
        </div>

        <TableRulesSushiLunch />
        <DrawerSauces
          title={<span style={{ fontSize: 18, fontWeight: 600 }}>Agregar una regla</span>}
          open={openModalCreateRule}
          width={"320px"}
          destroyOnClose
          onClose={() => setOpenModalCreateRule(false)}
          headerStyle={{ borderBottom: "1px solid #f0f0f0", padding: "16px 24px" }}
        >
          <RulesSushiLunchForm setOpenModalCreate={setOpenModalCreateRule} />
        </DrawerSauces>
      </div>
    </AdminMenuLayout>
  );
};
